import { render, staticRenderFns } from "./StoresView.vue?vue&type=template&id=6ddfc682&"
import script from "./StoresView.vue?vue&type=script&lang=ts&"
export * from "./StoresView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports